import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=15fad63a"
import script from "./BillForm.vue?vue&type=script&lang=js"
export * from "./BillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports